module.exports = __webpack_public_path__ + "/bundle/asset/exam-3-0caf164f9234233da269a93e46625394.png";